import { Admin, CustomRoutes, type DataProvider, Login, Resource } from 'react-admin'
import { Route } from 'react-router-dom'

import { authProvider } from './authProvider'
import { Layout } from './components/molecules/Layout'
import { HiddenPage } from './components/screens/HiddenPage'
import { ScaleList } from './components/screens/ScaleList'
import { ScaleShow } from './components/screens/ScaleShow'
import { SpecialEventCreate } from './components/screens/SpecialEventCreate'
import { SpecialEventEdit } from './components/screens/SpecialEventEdit'
import { dataProvider } from './dataProvider'
import { i18nProvider } from './i18n'
import { bombeoTheme } from './theme'

export interface AdminAppProps {
  dataProvider: DataProvider
  requireAuth: boolean
}

/** The admin with its data source injected, so tests render the real screens over their own data. */
export const AdminApp = ({ dataProvider, requireAuth }: AdminAppProps) => (
  <Admin
    layout={Layout}
    authProvider={requireAuth ? authProvider : undefined}
    dataProvider={dataProvider}
    i18nProvider={i18nProvider}
    theme={bombeoTheme(import.meta.env.MODE)}
    requireAuth={requireAuth}
    loginPage={Login}
  >
    {/* React Admin routes / to the first registered resource with a list. */}
    {/* Scales come from SÒSTRAT through bombeo-processor; the admin does not create them. */}
    <Resource name="scales" list={ScaleList} show={ScaleShow} recordRepresentation="id" />
    <Resource name="scale_events" create={SpecialEventCreate} edit={SpecialEventEdit} />
    {/* A page, not a resource: nothing is listed, created or edited. Login is required like everywhere else. */}
    {/* The SÒSTRAT read behind a key; not in the menu. */}
    <CustomRoutes>
      <Route path="/hidden" element={<HiddenPage />} />
    </CustomRoutes>
  </Admin>
)

// Data is only readable by logged-in users, so every build and the dev server log in.
export const App = () => <AdminApp dataProvider={dataProvider} requireAuth />
